import React, { useState } from "react";

import { ActionsMenu, MenuItem, ActionItem, BasicActionsMenuProps } from "ui/actions-menu";

import { getActionTouchpointTypeLabel } from "utilities";
import { TouchpointType } from "types/touchpoint";

import Icons from "assets";

interface TouchpointTableActionsMenuProps extends BasicActionsMenuProps {
  touchpointType: TouchpointType;
  onEdit: (id: string) => void;
  onOpenInEditor: (id: string) => void;
  onCreateDraft: (id: string) => void;
  onClone: (id: string) => void;
  onRemoveFromQueue: (id: string) => void;
}
const TouchpointsTableActionsMenu: React.FC<TouchpointTableActionsMenuProps> = ({
  item,
  touchpointType,
  onEdit,
  onOpenInEditor,
  onCreateDraft,
  onClone,
  onRemoveFromQueue,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const iconStyles = "text-gray-600 size-5";

  const actionItems: ActionItem[] = [
    {
      icon: <Icons.Document className={iconStyles} />,
      label: "Edit version details",
      onClick: (id: string) => {
        onEdit(id);
      },
    },
    {
      icon: <Icons.Edit className={iconStyles} />,
      label: "Open in editor",
      onClick: (id: string) => {
        onOpenInEditor(id);
      },
    },
    {
      icon: <Icons.NewDocument className={iconStyles} />,
      label: "Create draft from this version",
      onClick: (id: string) => {
        onCreateDraft(id);
      },
    },
    {
      icon: <Icons.Clone className={iconStyles} />,
      label: `Clone ${getActionTouchpointTypeLabel(touchpointType).toLowerCase()}`,
      onClick: (id: string) => {
        onClone(id);
      },
    },
    {
      icon: <Icons.Trash className={iconStyles} />,
      label: "Remove from queue",
      onClick: (id: string) => {
        onRemoveFromQueue(id);
      },
    },
  ];

  return (
    <ActionsMenu itemName={item.itemName} open={isOpen} onOpen={handleMenuOpen} onClose={handleMenuClose}>
      {actionItems.map((actionItem) => (
        <MenuItem
          key={actionItem.label}
          icon={actionItem.icon}
          label={actionItem.label}
          onClick={() => {
            actionItem.onClick(item.itemId);
            setIsOpen(false);
          }}
        />
      ))}
    </ActionsMenu>
  );
};

export default TouchpointsTableActionsMenu;
